import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

/** Any authenticated account can submit and manage its own events. */
export default function OrganizerRoute() {
  const loc = useLocation();
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("bb_user") || "null");
  } catch {
    user = null;
  }

  if (!user?.token) {
    const next = `${loc.pathname}${loc.search || ""}`;
    return (
      <Navigate
        to={`/login?next=${encodeURIComponent(next)}`}
        replace
        state={{ from: next }}
      />
    );
  }

  return <Outlet />;
}
